var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEntities = function SvgEntities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 48.446 47.752"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12162",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83902",
    d: "M27.998 47.002H2.75a2 2 0 01-2-2V11.531a2 2 0 012-2h7.52a2 2 0 012 2v4.608a1.994 1.994 0 01.727-.136h10.5V2.804c0-1.085.229-2.4 2.1-1.965l19.995 5.894c1.233.359 2.1.879 2.1 1.964v36.341a2.038 2.038 0 01-2.1 1.965z",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12161",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83729",
    d: "M32.998 12.772v24.286"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83730",
    d: "M39.385 12.772v24.286"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83898",
    d: "M5.498 23.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83899",
    d: "M5.498 15.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83900",
    d: "M5.498 39.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83901",
    d: "M5.498 31.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83894",
    d: "M15.498 21.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83895",
    d: "M15.498 37.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83896",
    d: "M15.498 29.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83892",
    d: "M21.498 21.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83897",
    d: "M21.498 37.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83893",
    d: "M21.498 29.002h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83903",
    d: "M12.998 16.002h13a2 2 0 012 2v29h-17v-29a2 2 0 012-2z",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
};

export default SvgEntities;